import axios from 'axios'
import {API_URL} from '../../utils/consts'

export async function accountExistsValidator(identificator) {
    try {
        const {data: {registered: registered}} = await axios.post(`${API_URL}/account/exists`, {login: identificator}, {headers: {'content-type': 'application/json'}})
        return registered
      } catch (e) {
        console.log(e)
    }
    return true
}